<fgb-banner [pageTitle]="'marketplace.page.title'"></fgb-banner>
<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<div class="container rewards-list-container">
  <fgb-upgrade-banner></fgb-upgrade-banner>
  <div>
    <fgbcl-marketplace-list
      [isList]="true"
      [marketplaceItemView]="true"
      [marketplaceItemTypes]="[0, 1, 2]"
      [defaultSort]="0"
    ></fgbcl-marketplace-list>
  </div>
</div>
